export default __webpack_public_path__ + "static/media/shirt-1-mobile.853da228.png";